// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9c395b96","633":"397ead0a"}[chunkId] + ".chunk.js";
};